import * as React from "react";
import { TextField, Button, Stack, InputAdornment } from "@mui/material";
import { Save } from "@mui/icons-material";
import ModalUI from "../UI/ModalUI";
import { useDispatch } from "react-redux";
import {
  createShareholding,
  updateShareholding,
} from "../../store/shareholding";

const AksionerModalEditor = (props) => {
  const dispatch = useDispatch();
  const { data, isstatusnew, oshmaId, open } = props;
  const [state, setState] = React.useState({
    name: "",
    percentage: "",
    oshmaId: oshmaId,
  });
  const [errorValues, setErrorValues] = React.useState([]);

  React.useEffect(() => {
    setErrorValues([]);
    setState({
      id: data?.id ? data.id : "",
      name: data?.name ? data.name : "",
      percentage: data?.percentage ? data.percentage : "",
    });
  }, [data, open]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value ? value : "" });
  };

  const saveShareholder = () => {
    var initialError = [];
    Object.keys(state).map(function (key, index) {
      if (state[key] !== "" || Object.keys(state[key]).length !== 0) {
      } else {
        initialError.push(key);
      }
    });

    setErrorValues(initialError);

    var initialErrorTemp = [];
    initialErrorTemp = initialError.filter((item) => item !== "id"); // remove id item

    if (initialErrorTemp.length === 0) {
      if (isstatusnew) {
        const { id, ...newShareholder } = state;
        dispatch(
          createShareholding({
            shareholding: { ...newShareholder, oshmaId: oshmaId },
          })
        );
      } else {
        dispatch(
          updateShareholding({ shareholding: { ...state, oshmaId: oshmaId } })
        );
      }
      props.onClose();
    }
  };

  const checkError = (item) => {
    if (errorValues.find((element) => element === item)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <ModalUI {...props}>
      <Stack spacing={2}>
        <TextField
          name="name"
          autoComplete="off"
          id="name"
          variant="outlined"
          error={checkError("name")}
          helperText={checkError("name") ? "Emri është i detyruar" : null}
          InputProps={{
            startAdornment: (
              <InputAdornment
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
                position="start"
              >
                Emër
              </InputAdornment>
            ),
          }}
          value={state.name}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack spacing={2}>
        <TextField
          name="percentage"
          autoComplete="off"
          id="percentage"
          type="number"
          variant="outlined"
          error={checkError("value")}
          helperText={checkError("value") ? "Vlera është e detyruar" : null}
          InputProps={{
            startAdornment: (
              <InputAdornment
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
                position="start"
              >
                Vlera (%)
              </InputAdornment>
            ),
          }}
          value={state.percentage}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack sx={{ display: "flex", width: "100%" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "primary.dark",
            display: "flex",
            marginTop: "40px",
          }}
          startIcon={<Save />}
          onClick={saveShareholder}
        >
          {isstatusnew ? "Shto" : "Ndrysho"}
        </Button>
      </Stack>
    </ModalUI>
  );
};
export default AksionerModalEditor;
